import { motion } from 'framer-motion';

export const Section = ({
  children,
  className = '',
  id,
  background = 'white',
  paddingY = 'py-24 lg:py-32',
}) => {
  const bgClasses = {
    white: 'bg-white',
    surface: 'bg-[#F8F9FA]',
    dark: 'bg-[#1A1A1A] text-white',
    gradient: 'hero-gradient',
  };

  return (
    <section
      id={id}
      className={`${paddingY} ${bgClasses[background] || bgClasses.white} ${className}`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {children}
      </div>
    </section>
  );
};

export const SectionTitle = ({
  eyebrow,
  title,
  description,
  align = 'left',
  dark = false,
}) => {
  const alignClasses = {
    left: 'text-left',
    center: 'text-center mx-auto',
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className={`max-w-3xl mb-12 lg:mb-16 ${alignClasses[align]}`}
    >
      {eyebrow && (
        <span className="text-sm font-medium uppercase tracking-widest text-[#29ABE2] mb-4 block">
          {eyebrow}
        </span>
      )}
      <h2
        className={`text-4xl lg:text-5xl font-bold tracking-tight uppercase mb-4 ${
          dark ? 'text-white' : 'text-[#1A1A1A]'
        }`}
      >
        {title}
      </h2>
      {description && (
        <p
          className={`text-lg leading-relaxed ${
            dark ? 'text-gray-400' : 'text-[#6C757D]'
          }`}
        >
          {description}
        </p>
      )}
    </motion.div>
  );
};

export const FadeIn = ({ children, delay = 0, className = '' }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export const StaggerContainer = ({ children, className = '' }) => {
  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      variants={{
        hidden: { opacity: 0 },
        visible: {
          opacity: 1,
          transition: {
            staggerChildren: 0.1,
          },
        },
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export const StaggerItem = ({ children, className = '' }) => {
  return (
    <motion.div
      variants={{
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
};
